import * as Yup from 'yup'

import { UserEmailLength, UserPasswordLength } from '@const/consts'
import { Warning } from '@const/translations'

export default Yup.object().shape({
  email: Yup.string()
    .trim()
    .max(UserEmailLength.MAX, Warning.max[UserEmailLength.MAX])
    .required(Warning.required),
  password: Yup.string()
    .max(UserPasswordLength.MAX, Warning.max[UserPasswordLength.MAX])
    .min(UserPasswordLength.MIN, Warning.min[UserPasswordLength.MIN])
    .required(Warning.required)
})
